import { ButtonPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import FormikInputText from "common/components/FormikFields/FormikInputText"
import Modal from "common/components/Modal/Modal"
import { countries, DEFAULT_COUNTRY_SELECTED } from "common/constants/countries"
import { validateCif, validateRazonSocial } from "common/utils/formValidations"
import { LeyAntiFraudeFormModal } from "feature-based/features/verifactu/organisms"
import { ModalValidacion } from "features/User/forms/PerfilEmpresa/ModalValidacion"
import { getValidateModalStatusSelector } from "features/User/redux/selectors/userSelectors"
import {
  setHideValidarEmpresaModal,
  setShowValidarEmpresaModal,
  settHideValidarEmpresaErrorModal,
} from "features/User/redux/slices/empresaSlice"
import {
  userSelector,
  validateEmpresa,
} from "features/User/redux/slices/userSlice"
import { withFormik } from "formik"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect, useState } from "react"
import ReactFlagsSelect from "react-flags-select"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { useLocation } from "react-router-dom"
import * as Yup from "yup"
import { MODES_MODAL_VARIFICACION } from "./VerificarEmpresaNotification/constant"
import VerificarEmpresaNotification from "./VerificarEmpresaNotification/index"

const Empresa = ({
  handleSubmit,
  verificado,
  values: { codigoPais },
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()

  const {
    activeCompany: { razonSocial, nif },
  } = useUsuarioEmpresaActiva()
  const { showValidarEmpresaModal, showValidarEmpresaErrorModal } = useSelector(
    getValidateModalStatusSelector
  )

  const [isLeyAntifraudeModalOpen, setIsLeyAntifraudeModalOpen] =
    useState(false)
  const [hasCheckedQueryParam, setHasCheckedQueryParam] = useState(false)

  useEffect(() => {
    if (hasCheckedQueryParam) return

    const params = new URLSearchParams(location.search)
    if (params.get("openLeyAntifraude") === "true") {
      setIsLeyAntifraudeModalOpen(true)
      setHasCheckedQueryParam(true)
    }
  }, [location.search, hasCheckedQueryParam])

  const handleCloseValidateModal = () => {
    dispatch(setHideValidarEmpresaModal())
  }

  const handleCloseLeyAntifraudeModal = () => {
    setIsLeyAntifraudeModalOpen(false)
  }

  const handleCloseValidateModalError = () => {
    dispatch(settHideValidarEmpresaErrorModal())
  }

  const handleShowValidateModal = (e: $TSMigrationFixMe) => {
    e.preventDefault()
    dispatch(setShowValidarEmpresaModal())
  }

  const onHandleSubmit = () => {
    handleSubmit()
    handleCloseValidateModal()
  }

  return (
    <form className='tw-mt-4'>
      <div className='tw-text-left tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-mb-6'>
        <div className='selected-country-mix-cif'>
          <label>{t("perfilEmpresa.company.nif")}</label>
          <ReactFlagsSelect
            disabled
            // @ts-expect-error TS(2322): Type '{ disabled: true; name: string; className: s...
            name='codigoPais'
            className='tw-w-full selected-country-mix-cif__select-country-field static-select-country'
            selected={codigoPais || DEFAULT_COUNTRY_SELECTED}
            customLabels={countries}
            showSelectedLabel={false}
          />

          <FormikInputText
            placeholder={`${t("perfilEmpresa.company.placeholderCif")}`}
            className='tw-w-full selected-country-mix-cif__input-cif-field selected-country-mix-cif__input-padding-flag'
            name='cif'
            disabled
            id='cif'
          />
        </div>
        <div>
          <label>{t("perfilEmpresa.company.companyName")}</label>

          <FormikInputText
            placeholder={`${t("perfilEmpresa.company.placeholderCompanyName")}`}
            className='tw-w-full'
            disabled
            name='razonSocial'
            id='razonSocial'
          />
        </div>
        <div className='tw-items-end tw-flex'>
          {verificado ? (
            <span className='tw-items-center tw-justify-center tw-rounded-md tw-py-2 tw-px-3 tw-border tw-border-solid tw-border-transparent tw-text-base tw-flex tw-bg-success tw-opacity-80 tw-text-white'>
              <FontAwesomeIcon
                className='tw-w-5 tw-h-5'
                icon={["fal", "circle-check"]}
              />
              <span className='tw-ml-2'>
                {t("perfilEmpresa.company.validated")}
              </span>
            </span>
          ) : (
            <ButtonPrimeReact
              className='tw-rounded-md tw-py-2 tw-px-3 tw-border tw-border-solid !tw-border-secondary tw-text-base !tw-bg-secondary hover:!tw-bg-secondary-over'
              type='button'
              onClick={handleShowValidateModal}
            >
              <FontAwesomeIcon
                className='tw-w-5 tw-h-5'
                icon={["fal", "circle-check"]}
              />
              <span className='tw-ml-2'>
                {t("perfilEmpresa.company.validate")}
              </span>
            </ButtonPrimeReact>
          )}
          <Modal
            onHide={handleCloseValidateModal}
            visible={showValidarEmpresaModal}
            className='!tw-w-128 tw-rounded-lg'
            closable={false}
            showHeader={false}
            breakpoints={false}
            contentClassName='!tw-p-0 !tw-rounded-lg'
          >
            <VerificarEmpresaNotification
              empresaActivaRazonSocial={razonSocial}
              onHide={handleCloseValidateModal}
              onSubmit={onHandleSubmit}
              mode={MODES_MODAL_VARIFICACION.VALIDAR}
            />
          </Modal>
          <Modal
            onHide={handleCloseValidateModalError}
            visible={showValidarEmpresaErrorModal.show}
            className='!tw-w-112 tw-rounded-lg'
            closable={false}
            showHeader={false}
            breakpoints={false}
            contentClassName='!tw-p-0 !tw-rounded-lg'
          >
            <VerificarEmpresaNotification
              empresaActivaRazonSocial={razonSocial}
              errorInfo={showValidarEmpresaErrorModal.info}
              onHide={handleCloseValidateModalError}
              onSubmit={handleCloseValidateModalError}
              mode={MODES_MODAL_VARIFICACION.ERROR}
            />
          </Modal>
        </div>
      </div>
      <ModalValidacion />
      {isLeyAntifraudeModalOpen && (
        <LeyAntiFraudeFormModal
          isOpen={isLeyAntifraudeModalOpen}
          handleCloseModal={handleCloseLeyAntifraudeModal}
          nif={nif ?? ""}
          razonSocial={razonSocial ?? ""}
        />
      )}
    </form>
  )
}

const validateProfile = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    cif: Yup.string().when("codigoPais", {
      is: DEFAULT_COUNTRY_SELECTED,
      then: validateCif(t),
    }),
    razonSocial: validateRazonSocial(t),
  })

const Validar = withFormik({
  mapPropsToValues: ({
    // @ts-expect-error TS(2339): Property 'activeCompany' does not exist on type '{...
    activeCompany: { nif: cif, razonSocial },
    // @ts-expect-error TS(2339): Property 'codigoPais' does not exist on type '{}'.
    codigoPais,
  }) => ({
    cif,
    razonSocial,
    codigoPais,
  }),
  validationSchema: ({ t }: $TSMigrationFixMe) => validateProfile(t),
  handleSubmit: (values, { props }) => {
    // @ts-expect-error TS(2339): Property 'validate' does not exist on type 'object...
    props.validate(values)
  },
})(Empresa)

const mapStateToProps = (state: $TSMigrationFixMe) => {
  return {
    verificado: userSelector(state).verificado,
    codigoPais: userSelector(state).empresaActiva.pais,
  }
}
const mapDispatchToProps = (dispatch: $TSMigrationFixMe) => ({
  validate: (payload: $TSMigrationFixMe) => {
    dispatch(validateEmpresa(payload, dispatch))
  },
})
// TODO: Redux connect should be deprecated
export default connect(mapStateToProps, mapDispatchToProps)(Validar)
